<template>
  <div>
    <h6>Hi-3</h6>
    <hr class="divider" />
    <wizard-nav :currentStepIndex="currentStepIndex" :currentStep="currentStep" :altMode="currentStepAltMode"
                :steps="steps" :showNav="false" @toPrevious="setPreviousStep" @toNext="setNextStep">
      <introduction v-if="currentStepIndex === 0" />
      <personal-information v-if="currentStepIndex === 1" />
      <retirement-information v-if="currentStepIndex === 2" />
      <career-progression v-if="currentStepIndex === 3" />
      <results v-if="currentStepIndex === 4" />
    </wizard-nav>
    <modal
      :value="stepLoading" :header="false" :footer="false"
      :backdrop="false" :keyboard="false" size="sm" @show="stepLoadingModalShown"
    >
      <div class="text-center">
        <img src="/DesktopModules/MVC/MilitaryPayCalculatorsMVC/Resources/images/loading.gif" />
      </div>
    </modal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { Modal } from 'uiv';

import { getMilitaryPayCalculatorSettings } from '@/js/api/calculator';

import EventBus from '@/js/utilities/event-bus';
import WizardNav from '@/js/components/wizard-nav';
import Introduction from './introduction';
import PersonalInformation from './personal-information';
import RetirementInformation from './retirement-information';
import CareerProgression from './career-progression';
import Results from './results';

export default {
  components: {
    'modal': Modal,
    'wizard-nav': WizardNav,
    'introduction': Introduction,
    'personal-information': PersonalInformation,
    'retirement-information': RetirementInformation,
    'career-progression': CareerProgression,
    'results': Results,
  },

  methods: {
    ...mapActions([
      'setPreviousStep',
      'setNextStep',
      'setMilitaryPayCalculatorSettings',
    ]),

    async getMilitaryPayCalculatorSettings() {
      try {
        const data = await getMilitaryPayCalculatorSettings(this);
        this.setMilitaryPayCalculatorSettings(data);
      } catch (e) {
        this.$toast.error(
          'This calculator has encountered an error. We apologize for the inconvenience. Please refresh and try again.',
          { duration: 3600000, dismissible: false },
        );
      }
    },

    stepLoadingModalShown() {
      EventBus.$emit('stepLoadingModalShown');
    },
  },

  created() {
    this.getMilitaryPayCalculatorSettings();
  },

  computed: {
    ...mapState([
      'moduleId',
      'tabId',
      'requestVerificationToken',
      'steps',
      'militaryPayCalculatorSettings',
      'currentStepIndex',
      'currentStepAltMode',
      'stepLoading',
    ]),
    ...mapGetters([
      'currentStep',
    ]),
  },
};
</script>

<style lang="scss">
.popover {
  z-index: 9999999;
}
</style>
